module.exports = __webpack_public_path__ + "img/invert_red.5615cb9f.webp";